import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminChangeUserPassword = () => {
  const queryClient = useQueryClient();

  return apiClient.admin.changePassword.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users-list'] });
      toast.success('Password changed successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error changing password!');
    },
  });
};
